<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="city_shop_freights"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" :title="$t('pages_city_shop_freights_index_246')">
      <Form ref="city_shop_freight" :model="city_shop_freight" :rules="rules" :label-width="80">
        <Form-item :label="$t('pages_city_shop_freights_index_247')" prop="freight">
          <Input type="number" v-model="city_shop_freight.freight"/>
        </Form-item>
        <Form-item :label="$t('pages_city_shop_freights_index_248')"
                   prop="province_id">
          <Select v-model="city_shop_freight.province_id"
                  @on-change="onProvinceChange">
            <Option v-for="(item, index) in provinces"
                    :key="index"
                    :value="item.id">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_city_shop_freights_index_249')"
                   prop="city_id">
          <Select v-model="city_shop_freight.city_id">
            <Option v-for="item in cities"
                    :key="item.id"
                    :value="item.id">{{ item.name }}</Option>
          </Select>
        </Form-item>
      </Form>
      <div slot="footer">
          <Button @click="modalShow = false">{{$t('pages_city_shop_freights_index_250')}}</Button>
          <Button @click="handleSubmit" type="primary">{{$t('pages_city_shop_freights_index_251')}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'
const freightValidate = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(i18n.t('pages_city_shop_freights_index_252')));
  } else {
    if (+value < 0) {
      callback(new Error(i18n.t('pages_city_shop_freights_index_253')));
    }
    callback();
  }
}
export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      rules: {
        freight: { validator: freightValidate, trigger: 'blur' },
        province_id: [{ required: true, message: i18n.t('pages_city_shop_freights_index_254') }],
        city_id: [{ required: true, message: i18n.t('pages_city_shop_freights_index_255') }],
      },
      citys: [],
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_city_shop_freights_index_256'),
          key: 'city_name'
        },
        {
          title: i18n.t('pages_city_shop_freights_index_247'),
          key: 'freight'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_city_shop_freights_index_257'),
          key: 'updated_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  watch: {
    modalShow: function (val) {
      if (val) {
        this.$refs.city_shop_freight.resetFields()
        setTimeout(async () => {
          const { province_id } = this.city_shop_freight;
          this.fetchProvinces()
          province_id && await this.fetchCities(province_id)
        }, 200)
      }
    }
  },
  computed: {
    ...mapGetters('city_shop_freight', ['city_shop_freight', 'city_shop_freights', 'meta', 'loading']),
    ...mapState('area', ['provinces', 'cities']),
  },
  methods: {
    ...mapActions('city_shop_freight', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('city_shop_freight', ['changeQuery']),
    ...mapActions('area', ['fetchProvinces', 'fetchCities', 'fetchDistricts']),
    onProvinceChange (id) {
      id && this.fetchCities(id)
      this.city_shop_freight.city_id = '';
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    handleSubmit () {
      this.$refs.city_shop_freight.validate(async valid => {
        if (valid) {
          if (this.formType === 'edit') {
            await this.update(this.city_shop_freight)
          } else if (this.formType === 'new') {
            await this.create(this.city_shop_freight)
          }
          this.modalShow = false
        }
      });
    }
  }
}
</script>
